import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email.trim(), password);
            navigate(location.state?.from || "/app", { replace: true });
        } catch (err) {
            setError(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            title="Hola otra vez"
            subtitle="Entra para ver tu piel, tu neceser y tu rutina donde los dejaste."
            footer={
                <>
                    ¿Aún no tienes cuenta?{" "}
                    <Link to="/crear-cuenta" className="font-medium text-terracotta hover:underline">
                        Créala gratis
                    </Link>
                </>
            }
        >
            <form onSubmit={submit} className="space-y-5" noValidate>
                {error && (
                    <div data-testid="login-error" className="rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-3 text-[14px] text-destructive">
                        {error}
                    </div>
                )}
                <div className="space-y-2">
                    <Label htmlFor="email">Correo electrónico</Label>
                    <Input id="email" type="email" value={email} autoComplete="email"
                        onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                        placeholder="tu@correo.es" required />
                </div>
                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <Label htmlFor="password">Contraseña</Label>
                        <Link to="/recuperar" className="text-[13px] text-subtle hover:text-ink">
                            ¿La has olvidado?
                        </Link>
                    </div>
                    <Input id="password" type="password" value={password} autoComplete="current-password"
                        onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                        placeholder="••••••••" required />
                </div>
                <Button type="submit" disabled={loading} data-testid="login-submit"
                    className="w-full h-11 text-[15px]">
                    {loading ? "Entrando…" : "Entrar"}
                </Button>
            </form>
        </AuthShell>
    );
}
